"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewRender = void 0;
const newEndpoint_1 = require("../newEndpoint");
exports.viewRender = (0, newEndpoint_1.newEndpoint)({
    nameSpace: newEndpoint_1.NameSpace.MUNICIPIO_V1,
    route: 'view/render',
    method: 'GET'
});
